import {
  Directive, Input, TemplateRef, ViewContainerRef,
  EmbeddedViewRef, OnDestroy, OnChanges, SimpleChanges
} from '@angular/core';

@Directive({ 
    selector: '[cdPaused]', 
    standalone: false
})
export class CdPausedDirective implements OnChanges, OnDestroy {
  @Input('cdPaused') paused = false;

  private view: EmbeddedViewRef<unknown>;

  constructor(private vcr: ViewContainerRef, private tpl: TemplateRef<unknown>) {
    this.view = this.vcr.createEmbeddedView(this.tpl);
  }

  ngOnChanges(_: SimpleChanges): void {
    if (this.paused) {
      this.view.detach();                      
    } 
    else {
      this.view.reattach();                     
      queueMicrotask(() => this.view.detectChanges()); 
    }
  }

  ngOnDestroy(): void { 
    this.view.reattach(); 
}
}
